import { useUIContext } from 'lib/context/UIContext/UIContext';
import { cn } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';
import Typography from 'components/shared/Typography/Typography';

const TableBodyHeader = ({
  value = '',
  description,
  children,
  actions,
  className,
  valueClassName,
  descriptionClassName,
  icon,
  variant = 'primary',
  type = 'primary',
  bodyClassName
}) => {
  const isPrimary = variant === 'primary';
  const isAlternative = type === 'alternative';
  const { device } = useUIContext();
  const isMobile = device === 'tablet-sm' || device === 'mobile';

  return (
    <div
      className={cn(
        'flex h-fit w-full items-center gap-2 p-0 px-2 text-left sm:px-4',
        isPrimary ? 'bg-primary-100' : 'bg-neutral-100 ',
        isPrimary && isAlternative && 'bg-primary-100',
        !isPrimary && isAlternative && 'bg-neutral-50',
        className
      )}>
      <div className="flex h-fit items-center gap-2.5 py-3 sm:items-start">
        {!isMobile && actions}
        <div className={cn('flex h-fit flex-col justify-center gap-2.5', bodyClassName)}>
          <div className="flex items-center gap-2.5">
            {isMobile && actions}
            {icon && <Icon icon={icon} size={16} />}
            {typeof value === 'string' ? (
              <Typography
                variant="label"
                size="medium"
                weight="medium"
                color="neutral-800"
                className={cn('whitespace-nowrap', valueClassName)}>
                {value}
              </Typography>
            ) : (
              value
            )}
          </div>
          {typeof description === 'string' ? (
            <Typography
              variant="label"
              size="medium"
              color="neutral-500"
              className={cn('whitespace-pre-line break-words italic', descriptionClassName)}>
              {description}
            </Typography>
          ) : (
            description
          )}
        </div>
      </div>
      {children}
    </div>
  );
};

export default TableBodyHeader;
